import { queryOptions } from '@tanstack/react-query';
import { apiDocumentRepository } from 'services/documents/ApiDocumentRepository';
import { QueryKeys } from 'utils/queryKeys';

export const signeesQueries = {
  list: (accountId: number) =>
    queryOptions({
      queryKey: QueryKeys.getSignees(accountId, ''),
      queryFn: () => apiDocumentRepository.getSignees(accountId, { searchText: '', offset: 0, limit: 100 }),
    }),
  search: (accountId: number, searchText: string) =>
    queryOptions({
      queryKey: QueryKeys.getSignees(accountId, searchText),
      queryFn: () => apiDocumentRepository.getSignees(accountId, { searchText, offset: 0, limit: 10 }),
    }),
};
